import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

export const Corpo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-width: 460px;
  max-width: 520px;

  h5 {
    margin-bottom: 20px;
    color: ${Cores.PRIMARIA_1};
  }
`

export const Resumo = styled.p`
  margin-top: 8px;
  font-size: 12px;
  color: ${Cores.CINZA_2};
`

export const AcoesModal = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`
